export const mapToolsForDisplay = (tools, lang) => {
    return tools?.map(tool => ({ ...tool, name: tool.name?.[lang] ?? tool.name })) ?? [];
};
